import cloneDeep from 'lodash/cloneDeep'
import template from './_lead-tags-form.pug'

export default Vue.extend({
  template: template(),
  props: {
    initData: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    mode: {
      type: String,
      validator: value => ['new', 'edit'].includes(value)
    }
  },
  data() {
    return {
      data: cloneDeep(this.initData),
      $lengths: { 
        leadTag: {
          name: { maximum: 255 }
        }
      }
    }
  },
  computed: {
    fieldTypeSelectOptions() {
      return Object.keys(FIELD_TYPES).map(key => ({
        label: this.$t(`campaigns.show.config.tabs.leadTags.fieldTypes.${key}`),
        value: FIELD_TYPES[key]
      }))
    },

    title() {
      return this.t(`${this.mode}Title`)
    },

    saveButtonText() {
      return this.t(`${this.mode}Button`)
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.data = cloneDeep(this.initData)
    },

    close() {
      try {
        this.$emit('close')
      } catch (error) {
        console.error('Error closing form:', error)
      }
    },

    submit() {
      try {
        this.$emit('submit', this.data)
      } catch (error) {
        console.error('Error submitting form:', error)
      }
    },

    t(key, options = {}) {
      return this.$t(`campaigns.show.config.tabs.leadTags.${key}`, options)
    }
  }
})
